import React, { FC, ReactElement, useEffect, useState } from "react";
import { Divider, Grid, Popover, TextField, Typography } from "@mui/material";
import AccordianList from "../RightSidebar/Accordian";
import AddButton from "../RightSidebar/AddButton";
import DoneIcon from "@mui/icons-material/Done";
import apiCall from "../../utils/apiCall";
import { CREATE_USER_FOLDER, GET_USER_FOLDERS,GET_SHARED_COLLECTION } from "../../endpoint";
import CollectionFolder from "./CollectionFolder";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  getloadingforsharedDocs,
  getloadingforindexes,
  loadingforSharedDocs,
} from "../../redux/slices/loadingSlice";
import { addError } from "../../redux/slices/errorSlice";
import SearchInput from "../RightSidebar/SearchInput";
import Loader from "../Loader";
interface CollectionProps {
  showSearch: string;
  setShowSearch: any;
  searchText: string;
  setSearchText: any;
}
const Collection: FC<CollectionProps> = ({
  showSearch,
  setShowSearch,
  searchText,
  setSearchText,
}): ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & HTMLDivElement) | null
  >(null);
  const dispatch = useAppDispatch();
  const [collectionName, setCollectionName] = useState<string>("");
  const [collections, setCollections] = useState<{ [key: string]: unknown }[]>([]);
  const [sharedCollection, setSharedCollection] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const indexloading = useAppSelector(getloadingforindexes);
  const sharedDocsLoading = useAppSelector(getloadingforsharedDocs);
  const [newlyCreatedCollection, setNewlyCreatedCollection] = useState<string | null>(null);
  useEffect(() => {
    const getUserCollections = () => {
      apiCall("POST", GET_USER_FOLDERS)
        .then((res) => {
          if (res) {
            const collectionsArray = Object.entries(res)
              .filter(([key]) => key !== 'isError')
              .flatMap(([_, value]) => {
                if (typeof value === 'object' && value !== null) {
                  return Object.entries(value).map(([key, items]) => ({
                    [key]: Array.isArray(items) ? items : []
                  }));
                }
                return [];
              });
            setCollections(collectionsArray);
            if (newlyCreatedCollection) {
              const isCreated = collectionsArray.some((item) =>
                Object.keys(item).includes(newlyCreatedCollection)
              );
              if (isCreated) {
                setCollectionName("");
                setNewlyCreatedCollection(null);
              }
            }
          } else {
            setCollections([]);
          }
          handleClose();
        })
        .catch((err) => {
          dispatch(
            addError("Failed to load all collections.Please try again.")
          );
        });
    };
    getUserCollections();
  }, [refresh]);

  useEffect(() => {
    const getSharedCollections = () => {
      dispatch(loadingforSharedDocs(true));
      apiCall("POST", GET_SHARED_COLLECTION)
        .then((res) => {
          setSharedCollection(res?.result);
          handleClose();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          dispatch(loadingforSharedDocs(false));
        });
    };

    //if(type === "shared")getSharedCollections();
    getSharedCollections();
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

 const createCollection = () => {
  const trimmedNmae=collectionName.trim().toLowerCase()
  const isDuplicate=collections.some((item)=>Object.keys(item)[0].toLowerCase()===trimmedNmae)
  if(isDuplicate){
    dispatch(addError("Collection with same already exist!"))
    handleClose()
    setCollectionName("")
    return;
  }
    if (!collectionName.trim()) {
      dispatch(addError("Collection name cannot be empty. Please enter a name."));
      return;
    }
    apiCall("POST", CREATE_USER_FOLDER, {
      folder_name: collectionName,
    })
      .then((res) => {
        if (res) {
          setNewlyCreatedCollection(collectionName);
          setRefresh((prev) => !prev);
        } else {
          dispatch(addError("Something went wrong. Please try again."));
        }
      })
      .catch(() => {
        dispatch(addError("Failed to create a collection. Please try again."));
      });
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <>
        <AccordianList
          title="Collections"
          addbutton={<AddButton onClick={(e) => handleClick(e)} />}
          height={20}
          showingLoaders={true}
          showSearch={collections?.length > 2 && showSearch !== "collections"}
          onSearchClick={() => setShowSearch("collections")}
        >
          <>
            {showSearch === "collections" && (
              <SearchInput
                onCancelClick={() => setShowSearch("")}
                searchText={searchText}
                setSearchText={setSearchText}
              />
            )}
            {collections
              ?.filter((item) =>
                Object.keys(item).some((key) =>
                  key?.toLowerCase().includes(searchText?.toLowerCase())
                )
              )
              ?.map((collection, i) => (
                <CollectionFolder
                  data={Object.entries(collection)[0]}
                  key={i}
                  refreshState={() => setRefresh(!refresh)}
                  category="Own"
                />
              ))}
          </>
        </AccordianList>
        <AccordianList
          title="Shared Collection"
          addbutton={<></>}
          height={20}
          showingLoaders={true}
          showSearch={sharedCollection?.length > 2 && showSearch !== "shared"}
          onSearchClick={() => setShowSearch("shared")}
        >
          <>
            {showSearch === "shared" && (
              <SearchInput
                onCancelClick={() => setShowSearch("")}
                searchText={searchText}
                setSearchText={setSearchText}
              />
            )}
            {sharedDocsLoading && <Loader />}
            {sharedCollection
              ?.filter((item) =>
                Object.keys(item).some((key) =>
                  key.toLowerCase().includes(searchText.toLowerCase())
                )
              )
              ?.map((collection, i) => (
                <CollectionFolder
                  data={Object.entries(collection)[0]}
                  key={i}
                  refreshState={() => setRefresh(!refresh)}
                  category="shared"
                  setSharedCollection={setSharedCollection}
                />
              ))}
          </>
        </AccordianList>
      </>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{
          ".MuiPopover-paper": {
            width: "300px",
          },
        }}
      >
        <Grid container alignItems="center">
          <TextField
            value={collectionName}
            onChange={(e) => setCollectionName(e.target.value)}
            label="Collection Name"
            // sx={{ mt: 2 }}
            variant="standard"
            sx={{
              m: 0.5,
              flex: 1,
            }}
            size="small"
            data-testid="newcollection"
          />
          <DoneIcon
            color="success"
            fontSize="small"
            onClick={() => createCollection()}
            sx={{
              mr: 1,
              cursor: "pointer",
            }}
          />
        </Grid>
      </Popover>
    </>
  );
};

export default Collection;
